import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoCreateComponent } from '../../producto/producto-create/producto-create.component';
import { ProductoService } from '../../producto/producto.service';
import { ServicioCreateComponent } from '../../servicio/servicio-create/servicio-create.component';
import { TipoRevisionCreateComponent } from '../../tipo-revision/tipo-revision-create/tipo-revision-create.component';
import { TipoRevisionService } from '../../tipo-revision/tipo-revision.service';
import { UsuarioCreateComponent } from '../../usuario/usuario-create/usuario-create.component';
import { UsuarioService } from '../../usuario/usuario.service';
import { VehiculoCreateComponent } from '../../vehiculo/vehiculo-create/vehiculo-create.component';
import { VehiculoService } from '../../vehiculo/vehiculo.service';
import { RevisionService } from '../revision.service';

@Component({
  selector: 'app-revision-venta',
  templateUrl: './revision-venta.component.html',
  styleUrls: ['./revision-venta.component.scss']
})
export class RevisionVentaComponent implements OnInit {

  encargados: any[] = [];
  productos: any[] = [];
  lineas: any[] = [];
  form: FormGroup = new FormGroup({});
  vehiculos: any[] = [];
  usuarios: any[] = [];
  tipo_aceites: any[] = [];
  tipos: any[] = [];

  tipoDocumento: number = 1;
  tipoPago: number = 1;

  get total() { return this.lineas.map(e => e.precio_unitario * e.cantidad).reduce((t, e) => t + e, 0) }

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    // public activeModal: NgbActiveModal,
    public service: RevisionService,
    public formatter: FormatterService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService,
    private productoService: ProductoService,
    private router: Router,
    private tipoService: TipoRevisionService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      tipo: [2, [Validators.required]],
      fecha: [null, [Validators.required]],
      detalle: [null, []],
    });

    this.form.patchValue({ fecha: new Date().toISOString().substring(0, 10), tipo: 2 })

    this.cargarProductos();
  }

  cargarProductos() {
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res.filter((e: any) => e.tipo == 1).map((e: any) => {
          e.tipo = e.tipo == 1 ? 'Producto' : 'Servicio'
          return e;
        });
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  addProducto() {
    const modalRef = this.modalService.open(ProductoCreateComponent, { size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.cargarProductos();
    }, (reason: any) => { });
  }

  searchFnProducto(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.codigo_barra, item.sku].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  agregarProducto() {
    let aux = this.lineas.slice(0)
    aux.push({
      producto_id: null,
      cantidad: 1,
      precio_unitario: 0
    });
    this.lineas = aux;
  }

  quitarProducto(index: number) {
    let aux = this.lineas.slice(0);
    aux.splice(index, 1);
    this.lineas = aux;
  }

  productoCambiado(ev: any, index: number) {
    if (ev) {
      let aux = this.lineas.slice(0);
      aux[index].precio_unitario = ev.precio_venta ?? 0;
      this.lineas = aux;
    }
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
      return;
    }

    if (this.lineas.map(element => !element.producto_id).reduce((t, e) => t || e, false)) {
      this.alerts.addAlert("Hay algunos productos o servicios que no se han seleccionado.", "warning");
      return;
    }

    this.loading.show();
    let data = Object.assign({}, this.form.value);
    data.lineas = this.lineas;
    data.tipo_pago = this.tipoPago;
    data.tipo_documento = this.tipoDocumento;
    this.service.insert(data).subscribe({
      next: (res) => {
        this.descargar(res);
        this.loading.hide();
        this.router.navigate(['revisiones/index-venta']);
        // this.activeModal.close(res.model);
        this.alerts.addAlert("Registro realizado con éxito.", "success");
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el registro.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  descargar(element: any) {
    this.loading.show();
    this.service.downloadPdf(element).subscribe({
      next: (res: any) => {
        this.loading.hide();
        let downloadURL = window.URL.createObjectURL(res);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${element.tipo == 3 ? 'Cotización' : element.tipo == 2 ? 'Venta' : 'Orden de Trabajo'} N°${element.correlativo}.pdf`;
        link.click();
      }, error: (err: any) => {
        this.loading.hide();
        this.alerts.addAlert('No se pudo descargar el documento.', 'danger');
      }
    });
  }

  cantidadCambiada(item: any) {
    if (!item.cantidad) item.cantidad = 1;
  }

  valorCambiado(item: any) {
    if (!item.precio_unitario) item.precio_unitario = 0;
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.usuario?.nombre, item.usuario?.apellido, item.patente].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }

}
